import { useAuth } from '@/auth/AuthContext';
import React, { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import Loading from '../Loading/Loading';

const LoginRedirect: React.FC = () => {
  const location = useLocation();
  const { login, isAuthenticated } = useAuth();
  const hasTriggeredLogin = useRef(false);

  useEffect(() => {
    // Don't redirect if already authenticated or login already triggered
    if (isAuthenticated || hasTriggeredLogin.current) {
      return;
    }

    const handleLoginRedirect = async () => {
      try {
        // Mark as triggered to prevent duplicate calls in React StrictMode
        hasTriggeredLogin.current = true;

        // Capture the current path to redirect back after login
        const redirectPath = location.pathname + location.search;
        login(redirectPath);
      } catch (error) {
        // Reset flag on error so user can retry
        hasTriggeredLogin.current = false;
        console.error('Login redirect error:', error);
      }
    };

    handleLoginRedirect();
  }, [login, location.pathname, location.search, isAuthenticated]);

  return <Loading />;
};

export default LoginRedirect;
